// extracted by mini-css-extract-plugin
export default {"Container":"Guide_Container__p9mU1"};